// extracted by mini-css-extract-plugin
export var dataCell = "_pu-2";
export var dataRow = "_pu-0";
export var headerRow = "_pu-1";